import { Avatar, Button, Divider, Form, Input, Select, Switch } from "antd";
import { FC } from "react";
import classNames from "classnames";

import styles from "./index.less";

import { FlowNodeInputItemType } from "@packages/flow-core/module/node/types";

import HumanIcon from "../../assets/imgs/human.png";
import { ModuleIOValueTypeEnum } from "@packages/flow-core/module";
import { FlowNodeInputTypeEnum } from "@packages/flow-core/module/node/constants";

interface ChatItemTemplateInputProps {
  inputs: FlowNodeInputItemType[];
  disableToSubmit: boolean; // 限制提交
  onSubmit: (values: Record<string, any>) => void;
}

/**
 * 直接渲染输出表单
 * @returns
 */
const ChatItemTemplateInput: FC<ChatItemTemplateInputProps> = ({
  inputs,
  disableToSubmit,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  return (
    <div className={classNames(styles["chat-item-human"], styles["chat-item"])}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
        className={styles["message-box"]}
      >
        <div className={styles["chat-item-human-content"]}>
          <div className={styles["plugin-input-container"]}>
            <div className={styles["plugin-input-title"]}>
              请输入模板所需参数
            </div>
            <Divider style={{ margin: "8px 0 20px 0" }} />
            <Form
              form={form}
              labelWrap={true}
              layout="vertical"
              onFinish={(values) => onSubmit(values)}
              disabled={disableToSubmit}
            >
              {inputs.map((input) => (
                <Form.Item
                  key={input.key}
                  name={input.key}
                  label={input.label}
                  initialValue={input.value}
                  required={input.required}
                  rules={[
                    {
                      required: input.required,
                      message:
                        input.type === FlowNodeInputTypeEnum.select
                          ? `请选择${input.label}`
                          : `请输入${input.label}`,
                    },
                  ]}
                  valuePropName={
                    input.valueType === ModuleIOValueTypeEnum.boolean
                      ? "checked"
                      : "value"
                  }
                >
                  {input.valueType === ModuleIOValueTypeEnum.string &&
                    (input.type === FlowNodeInputTypeEnum.input ||
                      input.type === FlowNodeInputTypeEnum.selectWxUser ||
                      input.type === FlowNodeInputTypeEnum.selectAppName ||
                      input.type === FlowNodeInputTypeEnum.uploadMaterial ||
                      input.type ===
                        FlowNodeInputTypeEnum.selectDamselfishTags) && (
                      <Input />
                    )}
                  {input.valueType === ModuleIOValueTypeEnum.string &&
                    input.type === FlowNodeInputTypeEnum.textarea && (
                      <Input.TextArea />
                    )}
                  {input.valueType === ModuleIOValueTypeEnum.string &&
                    input.type === FlowNodeInputTypeEnum.select && (
                      <Select options={input.list || []} />
                    )}
                  {input.valueType === ModuleIOValueTypeEnum.number && (
                    <Input type="number" />
                  )}
                  {input.valueType === ModuleIOValueTypeEnum.boolean && (
                    <Switch />
                  )}
                  {!["string", "number", "bool"].includes(
                    input.valueType ?? "string"
                  ) && <Input.TextArea />}
                </Form.Item>
              ))}

              <Button
                type="primary"
                disabled={disableToSubmit}
                className={styles["plugin-input-submit-btn"]}
                htmlType="submit"
              >
                确认
              </Button>
            </Form>
          </div>
        </div>
      </div>
      <Avatar shape="square" src={HumanIcon} className={styles.avatar} />
    </div>
  );
};

export default ChatItemTemplateInput;
